module.exports = __webpack_public_path__ + "img/default-user-icon.6dfac45c.svg";